module.exports = __webpack_public_path__ + "static/training-511f82186b90952016bfcdebda2d1bbc.jpg";